import { useLocation } from 'react-router-dom';
import TickMark from '../../Assets/Modals/TickMark.svg';

function Completed() {
    return (
        <div className="size-8 rounded-full flex items-center justify-center bg-primaryAccent shadow-[0px_0px_4px_0px_#00000040]">
            <img src={TickMark} alt="" />
        </div>
    )
}

function Number({ number }) {
    return (
        <div className="size-8 rounded-full flex items-center justify-center bg-[#DEDEDE] shadow-[0px_0px_4px_0px_#00000040]">
            <p className='text-[#999999]'>{number}</p>
        </div>
    )
}

function Selected() {
    return (
        <div className="size-8 rounded-full flex items-center justify-center bg-white border border-[#CCCCCC] shadow-[0px_0px_4px_0px_#00000040]">
            <div className="size-3 rounded-full bg-primaryAccent"></div>
        </div>
    )
}

function RegistrationProgressBar() {
    const location = useLocation();

    return (
        <div className='grid grid-cols-5 gap-6 font-medium text-[14px] leading-5 text-text1'>
            <div className="w-full flex flex-col items-center gap-2 relative z-0">
                {
                    location.pathname.includes('registration') ? 
                    <Selected /> : 
                    <Completed />
                }

                <p>Basic Information</p>

                <div className={`absolute h-[2px] w-[calc(100%+20px)] left-1/2 top-1/4 ${(location.pathname.includes('storesetup') || location.pathname.includes('bankdetails') || location.pathname.includes('agreement') || location.pathname.includes('businessinformation')) ? 'bg-primaryColor' : 'bg-[#DEDEDE]'} -z-10`}></div>
            </div>

            <div className="w-full flex flex-col items-center gap-2 relative z-0">
                {
                    location.pathname.includes('businessinformation') ? 
                    <Selected /> : 
                    (
                        location.pathname.includes('registration') ? 
                        <Number number={2} /> : 
                        <Completed />
                    )
                }

                <p>Business Information</p>

                <div className={`absolute h-[2px] w-[calc(100%+20px)] left-1/2 top-1/4 ${(location.pathname.includes('storesetup') || location.pathname.includes('bankdetails') || location.pathname.includes('agreement')) ? 'bg-primaryColor' : 'bg-[#DEDEDE]'} -z-10`}></div>
            </div>

            <div className="w-full flex flex-col items-center gap-2 relative z-0">                
                {
                    location.pathname.includes('storesetup') ? 
                    <Selected /> : 
                    (
                        (location.pathname.includes('businessinformation') || location.pathname.includes('registration')) ? 
                        <Number number={3} /> : 
                        <Completed />
                    )
                }

                <p>Store Setup</p>

                <div className={`absolute h-[2px] w-[calc(100%+20px)] left-1/2 top-1/4 ${(location.pathname.includes('bankdetails') || location.pathname.includes('agreement')) ? 'bg-primaryColor' : 'bg-[#DEDEDE]'} -z-10`}></div>
            </div>

            <div className="w-full flex flex-col items-center gap-2 relative z-0">
                {
                    location.pathname.includes('bankdetails') ? 
                    <Selected /> : 
                    location.pathname.includes('agreement') ? 
                    <Completed /> : 
                    <Number number={4} />
                }

                <p>Bank Details</p>

                <div className={`absolute h-[2px] w-[calc(100%+20px)] left-1/2 top-1/4 ${location.pathname.includes('agreement') ? 'bg-primaryColor' : 'bg-[#DEDEDE]'} -z-10`}></div>
            </div>

            <div className="w-full flex flex-col items-center gap-2 relative z-0">
                {
                    location.pathname.includes('agreement') ? 
                    <Selected /> : 
                    <Number number={5} />
                }

                <p>Agreement</p>
            </div>
        </div>
    )
}

export default RegistrationProgressBar;
